import React from 'react';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
import { LanguageSwitcher } from './LanguageSwitcher';
import { CookieConsent } from './CookieConsent';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <LanguageSwitcher />
      <CookieConsent />
    </div>
  );
}